<template>
    <div id="staff-rating-setting" class="vs-con-loading__container">
        <h4 class="text-2xl font-bold mb-6">Go POS Staff Rating</h4>

        <div class="flex align-center justify-between mr-base pr-3">
            <div>
                <p class="color-black font-bold text-lg">Device to display staff rating:</p>
                <p class="text-primary font-bold text-lg cursor-pointer" @click="openDevicePopup">See available device</p>
            </div>
            <v-select class="device-select" @input="selectId($event)" v-model="selected_device" label="device_name" :options="deviceOptions" :clearable="false" :searchable="false"></v-select>
        </div>
        <div v-if="selected_device">
            <div class="flex align-center">
                <vs-switch v-model="enable_staff_rating" class="my-6" @click="updateEnableStaffRating" />
                <span class="text-lg pl-5">Enable rating for staff on Go Checkin app</span>
            </div>
            <div v-if="answers">
                <div>
                    <div class="flex align-center justify-between mr-base pr-3 mb-6">
                        <p class="text-lg color-black font-bold">Option for store and overall:</p>
                        <vs-button type="filled" class="gradient gradient-primary no-shadow my-0" color="primary" icon-pack="feather" icon="icon-plus" 
                            v-if="answers && answers.store && answers.store.answer && answers.store.answer[answers.store.answer.length - 1].show_status != 3" @click="addAnswer('store')">Add new</vs-button>
                    </div>

                    <transition name="list">
                        <div v-if="answers && answers.store && answers.store.answer">
                            <div v-for="(answer, index) in answers.store.answer" :key="index" class="my-3">
                                <div class="flex align-center">
                                    <textarea class="mb-0 mr-3 p-3 w-full rounded-item review-input" type="text" :id="`rating-staff-setting-${index}`" :value="answer.content"
                                        @input="changeAnswer($event, index, 'store')" @change="changeAnswer($event, index, 'store')" 
                                        :class="{'border-new': answer.show_status==3}" />
                                    <vs-icon :id="[`save-add-${index}`]" v-if="answer.show_status != 1 && answer.content != ''" icon="check_circle" size="medium" color="primary" 
                                        @click.stop="openLoadingContained(index, answer), saveAdd('store', answer, index)" :key="'a' + index"
                                        class="cursor-pointer user-select-none vs-con-loading__container mr-2 save-add-animation"></vs-icon>
                                    <vs-icon icon="remove_circle" size="medium" color="danger" class="cursor-pointer user-select-none" @click.stop="startRemoveAnswer(answer, index, 'store'), updateActiveAnswer(answer)"></vs-icon>
                                </div>
                                <!-- <span class="text-xs text-danger" v-if="answer.content != '' && answer.content.trim().length < 10">Content should contain at least 10 characters.</span> -->
                            </div>
                        </div>
                    </transition>
                </div>

                <div>
                    <div class="flex align-center justify-between mt-base mr-base pr-3 mb-6">
                        <p class="text-lg color-black font-bold">Options for staff:</p>
                        <vs-button type="filled" class="gradient gradient-primary no-shadow my-0" color="primary" icon-pack="feather" icon="icon-plus"
                            v-if="answers && answers.service && answers.service.answer && answers.service.answer[answers.service.answer.length - 1].show_status != 3" @click="addAnswer('service')">Add new</vs-button>
                    </div>

                    <transition name="list">
                        <div v-if="answers && answers.service && answers.service.answer">
                            <div v-for="(answer, index) in answers.service.answer" :key="index" class="my-3">
                                <div class="flex align-center">
                                    <textarea class="mb-0 mr-3 p-3 w-full rounded-item review-input" type="text" :id="`rating-staff-setting-${index}`" :value="answer.content"
                                        @input="changeAnswer($event, index, 'service')" @change="changeAnswer($event, index, 'service')" 
                                        :class="{'border-new': answer.show_status==3}" />
                                    <vs-icon :id="[`save-add-${index}`]" v-if="answer.show_status != 1 && answer.content != ''" icon="check_circle" size="medium" color="primary"
                                        @click.stop="openLoadingContained(index, answer), saveAdd('service', answer, index)" :key="'a' + index" 
                                        class="cursor-pointer user-select-none vs-con-loading__container mr-2 save-add-animation"></vs-icon>
                                    <vs-icon icon="remove_circle" size="medium" color="danger" class="cursor-pointer user-select-none" @click.stop="startRemoveAnswer(answer, index, 'service'), updateActiveAnswer(answer)"></vs-icon>
                                </div>
                                <!-- <span class="text-xs text-danger" v-if="answer.content != '' && answer.content.trim().length < 10">Content should contain at least 10 characters.</span> -->
                            </div>
                        </div>
                    </transition>
                </div>
                <vs-popup class="holamundo delete-survey-review-popup" :title="`Delete Answer`" :active.sync="popupDeleteAnswer">
                    <div class="text-center">
                        <h3>Do you want to delete this answer?</h3>
                        <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                        <vs-button class="mr-6 align-center delete-responsive" @click="removeAnswer()">Delete</vs-button>
                        <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupDeleteAnswer = false">Cancel</vs-button>
                        </div>
                    </div>
                </vs-popup>
            </div>
        </div>

        <staff-rating-device-popup :popupDeviceConfig="popupDeviceConfig"></staff-rating-device-popup>
    </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
    name: 'v-staff-rating-setting',
    components: {
        'v-select': vSelect,
    },
    data() {
        let answers = this.$store.getters['reviewList/staffRatingAnswerList'];
        let activeAnswer = {};
        let loaded_data_num = 0;
        this.$store.dispatch('reviewList/GET_STAFF_RATING_ANSWER').then(() => {
            let answerList = this.$store.getters['reviewList/staffRatingAnswerList'];
            this.answers = answerList;
            if(answerList.store && answerList.store.answer && answerList.store.answer[0]) {
                this.updateActiveAnswer(answerList.store.answer[0]);
            }
            this.loaded_data_num++;
        }).catch((err) => {
            console.log('Error: ' + err);
        })
        return {
            deviceOptions: [],
            selected_device: null,
            answers,
            enable_staff_rating: true,
            activeAnswer,
            action_type: "",
            isOpenLoadingInDiv: false,
            isOpenLoadingInContained: false,
            popupDeleteAnswer: false,
            test_content: 'Need friendlier reception and welcome service',
            loaded_data_num,
            popupDeviceConfig: {
                isOpen: false
            }
        }
    },
    watch: {
        staffRatingAnswerList: {
            immediate: true,
            deep: true,
            handler() {
                let answerList = this.$store.getters['reviewList/staffRatingAnswerList'];
                this.answers = answerList;
                if(answerList.store && answerList.store.answer && answerList.store.answer[0]) {
                    this.activeAnswer = this.updateActiveAnswer(answerList.store.answer[0]);
                }
            }
        },
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 3) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get data";
                    this.openLoadingInDiv();
                }
            }
        },
        selected_device: {
            immediate: true,
            deep: true,
            handler() {
                this.getAnswerList();
            }
        },
        deviceList: {
            immediate: true,
            deep: true,
            handler() {
                this.initDeviceInfo();
            }
        }
    },
    methods: {
        selectId(e) {
            if(e) {
                let obj = {
                    id: e.id,
                    is_show_staff_rating: 1
                }

                if(!this.isOpenLoading) {
                    this.openLoadingInDiv();
                }
                this.action_type = "Get data";
                this.$store.dispatch('reviewList/UPDATE_STAFF_RATING_DEVICE', obj).then(() => {
                    // this.getAnswerList();
                    this.closeLoading();
                }).catch((err) => {
                    console.log('Error: ' + err);
                })
            }
        },
        openDevicePopup() {
            this.popupDeviceConfig.isOpen = true;
        },
        getAnswerList() {
            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.action_type = 'Get List';
            this.$store.dispatch('reviewList/GET_STAFF_RATING_ANSWER').then(() => {
                let answerList = this.$store.getters['reviewList/staffRatingAnswerList'];
                this.answers = answerList;
                if(answerList.store && answerList.store.answer && answerList.store.answer[0]) {
                    this.updateActiveAnswer(answerList.store.answer[0]);
                }
                this.closeLoading();
            }).catch((err) => {
                console.log('Error: ' + err);
            })
        },
        updateEnableStaffRating() {
            // let obj = {
            //     key: "config.pos.enable_staff_rating",
            //     value: !this.enable_staff_rating ? 1 : 0
            // }
            let data = {
                data: [
                    {
                        key: "config.pos.enable_staff_rating",
                        value: !this.enable_staff_rating ? 1 : 0,
                        comment: ""
                    },
                    {
                        key: "mercure_active",
                        value: !this.enable_staff_rating ? 1 : 0,
                        comment: ""
                    }
                ]
            }
            this.action_type = "Update Enable Staff Rating";
            this.openLoadingInDiv();
            this.$store.dispatch("appSetting/UPDATE_LIST_KEY_STORAGE", data).then(() => {
                this.closeLoading();
                this.$vs.notify({
                    title: "Notification",
                    text: this.action_type + " Success",
                    color: "success",
                    position: "top-right"
                });
            }).catch(() => {
                this.closeLoading();
                this.$vs.notify({
                    title: "Notification",
                    text: this.action_type + " Failed",
                    color: "danger",
                    position: "top-right"
                });
            });
        },
        updateActiveAnswer(answer) {
            this.activeAnswer = answer;
        },
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoadingInDiv = true;
            this.loadTime = setTimeout(() => {
                if (this.isOpenLoadingInDiv) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: this.action_type + " Rating Answer Failed",
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        openLoadingContained(index){
            this.$vs.loading({
                background: this.backgroundLoading,
                color: this.colorLoading,
                container: `#save-add-${index}`,
                type: "material",
                scale: 0.8
            })
            if (this.loadTime1) {
                clearTimeout(this.loadTime1);
                this.loadTime1 = null;
            }
            this.isOpenLoadingInContained = true;
            this.loadTime1 = setTimeout(() => {
                if (this.isOpenLoadingInContained) {
                    this.closeLoading(index);
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: this.action_type + " Rating Answer Failed",
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading(index) {
            this.isOpenLoadingInDiv = false;
            this.$vs.loading.close('#app > .con-vs-loading');
            if(index != undefined) {
                this.isOpenLoadingInContained = false;
                setTimeout( ()=> {
                    this.$vs.loading.close(`#save-add-${index} > .con-vs-loading`)
                }, 500);
            }
        },
        addAnswer(type) {
            let checkEmptyLines = this.answers[type].answer.filter(answer => { return answer.content === '' || answer.status === 3;});
            if (checkEmptyLines.length == 0) {
                return this.answers[type].addNewAnswer();
            }
        },
        changeAnswer(event, index, type){
            this.answers[type].answer[index].updateContent(event.target.value);
            //0: deleted, 1: not update, 2: updated, 3: new added
            if(this.answers[type].answer[index].show_status == 1 || this.answers[type].answer[index].show_status == 2) {
                this.answers[type].answer[index].changeShowStatus(2);
            }
        },
        startRemoveAnswer(answer, index, type) {
            this.updateActiveAnswer(answer);
            if(answer.show_status == 3) {
                this.answers[type].removeAnswer(index);
            } else {
                this.popupDeleteAnswer = true;
            }
        },
        saveAdd(type, answer, index) {
            let data = {
                type: type,
                content: answer.content,
                system: 'rating'
            }
            // if(answer.content.trim().length < 10) {
            //     this.$vs.notify({
            //         title: 'Notification'
            //     })
            // }
            if(answer.show_status == 2) {
                data.id = answer.id;
                this.action_type = "Update";
                this.$store.dispatch('reviewList/UPDATE_ANSWER', data).then(() => {
                    this.closeLoading(index);
                    this.$vs.notify({
                        title:'Success',
                        text:'Update Rating Answer Success',
                        color:'success'
                    })
                }).catch((err) => {
                    console.log('Error: ' + err);
                })
            } else {
                this.action_type = "Add";
                this.$store.dispatch('reviewList/CREATE_ANSWER', data).then(() => {
                    this.closeLoading(index);
                    this.$vs.notify({
                        title:'Success',
                        text:'Add Rating Answer Success',
                        color:'success'
                    })
                }).catch((err) => {
                    console.log('Error: ' + err);
                })
            }
        },
        removeAnswer() {
            let data = {
                id: this.activeAnswer.id,
                status: 0
            }
            this.action_type = 'Delete';
            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.$store.dispatch('reviewList/CHANGE_ANSWER_STATUS', data).then(() => {
                this.popupDeleteAnswer = false;
                this.closeLoading();
                this.$vs.notify({
                    title:'Success',
                    text:'Delete Rating Answer Success',
                    color:'success'
                })
            })
        },
        // getDeviceList() {
        //     if(!this.isOpenLoading) {
        //         this.openLoadingInDiv();
        //     }
        //     this.action_type = "Get Device List";
        //     this.$store.dispatch('reviewList/GET_DEVICE_LIST').then((res) => {
        //         this.deviceOptions = res.items;
        //         let has_show = false;
        //         if(res.items && res.items.length > 0) {
        //             for(let i = 0; i < res.items.length; i++) {
        //                 if(res.items[i].is_show_staff_rating == 1) {
        //                     this.selected_device = res.items[i];
        //                     has_show = true;
        //                     break;
        //                 }
        //             }
        //         }
        //         if(!has_show) {
        //             this.selected_device = null;
        //         }
        //         this.closeLoading();
        //     }).catch((err) => {
        //         console.log('Error: ' + err);
        //     });
        // },
        initDeviceInfo() {
            let has_show = false;
            if(this.deviceList && this.deviceList.items) {
                if(this.deviceList.items.length > 0) {
                    this.deviceOptions = this.deviceList.items;
                } else {
                    this.deviceOptions = [];
                }
                for(let i = 0; i < this.deviceList.items.length; i++) {
                    if(this.deviceList.items[i].is_show_staff_rating == 1) {
                        this.selected_device = this.deviceList.items[i];
                        has_show = true;
                        break;
                    }
                }
            }
            if(!has_show) {
                this.selected_device = null;
            }
        },
        getDeviceList() {
            this.$store.dispatch('reviewList/GET_DEVICE_LIST').then((res) => {
                this.deviceOptions = res.items;
                this.selected_device = null;
                if(res.items && res.items.length > 0) {
                    for(let i = 0; i < res.items.length; i++) {
                        if(res.items[i].is_show_staff_rating == 1) {
                            this.selected_device = res.items[i];
                            break;
                        }
                    }
                }
                if(this.selected_device == null) {
                    this.enable_staff_rating = false;
                    let data = {
                        data: [
                            {
                                key: "config.pos.enable_staff_rating",
                                value: 0,
                                comment: ""
                            },
                            {
                                key: "mercure_active",
                                value: 0,
                                comment: ""
                            }
                        ]
                    }
                    this.$store.dispatch("appSetting/UPDATE_LIST_KEY_STORAGE", data);
                }
                this.loaded_data_num++;
            });
        }
    },
    computed: {
        staffRatingAnswerList() {
            return this.$store.getters['reviewList/staffRatingAnswerList'];
        },
        deviceList() {
            return this.$store.getters['reviewList/deviceList'];
        }
    },
    created() {
        let enable_staff_rating = {
            key: "config.pos.enable_staff_rating"
        }
        this.$store.dispatch("appSetting/GET_KEY_STORAGE", enable_staff_rating).then((res) => {
            this.loaded_data_num++;
            this.enable_staff_rating = res.value == 1 ? true : false;
            this.getDeviceList();
        }).catch(() => {
            const obj = {
                key: "config.pos.enable_staff_rating",
                value: 0
            };
            this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
                this.loaded_data_num++;
                this.getDeviceList();
            });
        });
        // this.$store.dispatch('reviewList/GET_DEVICE_LIST').then((res) => {
        //     this.deviceOptions = res.items;
        //     if(res.items && res.items.length > 0) {
        //         for(let i = 0; i < res.items.length; i++) {
        //             if(res.items[i].is_show_staff_rating == 1) {
        //                 this.selected_device = res.items[i];
        //                 break;
        //             }
        //         }
        //     }
        //     this.loaded_data_num++;
        // });
    }
}
</script>